module.exports = __webpack_public_path__ + "img/3_ua.b86de63e.webp";